<ng-template #template>
  <svg [iconName]="iconName" 
    [size]="size" 
    [width]="width" 
    [height]="height" 
    [title]="title" 
    [css]="css"
    [partCss]="className"
     sv-ng-svg-icon>
  </svg>
</ng-template>